import { createRoot } from "react-dom/client"
import { Provider } from "react-redux"
import { BrowserRouter } from "react-router-dom"
import reportWebVitals from "./reportWebVitals"

import React from "react"
import { PersistGate } from "redux-persist/integration/react"
import App from "./App"
import { persistor, setupStore, store } from "./app/store"

import "shepherd.js/dist/css/shepherd.css"
import "./global.css"

import ChatGate from "./pages/chat-gate"
import MobileGate from "./pages/mobile-gate"

let appStore = store
const useMSW = process.env.REACT_APP_ENABLE_MSW?.toLowerCase() === "true"

if (process.env.NODE_ENV === "development") {
  // Pretty print env vars:
  console.debug("🔧 Environment variables:")
  for (const key in process.env) {
    console.debug(`${key.padEnd(20)} ${process.env[key]}`)
  }
}

// Remove below and replace with this when ready to do
// true prod deployment (not just mock server)
console.info(`🖥️ Running in ${process.env.NODE_ENV} mode`)
if (process.env.NODE_ENV === "test" || useMSW) {
  console.info("🥸 Starting mock server in browser")
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { mock } = require("./mocks/browser")
  mock.start()
}

if (process.env.NODE_ENV === "test") {
  console.info("🧪 Setting up app store for testing")
  appStore = setupStore() as typeof store
}

const container = document.getElementById("root")
const root = createRoot(container!)

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={appStore}>
        <PersistGate loading={null} persistor={persistor}>
          <MobileGate>
            <ChatGate>
              <App />
            </ChatGate>
          </MobileGate>
        </PersistGate>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
